import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { collection, getDocs } from "firebase/firestore";
import styles from "./RelatedVideoList.module.css";

const RelatedVideoList = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        console.log("🔥 Firestore에서 관련 영상 불러오기...");
        const videoRef = collection(db, "relatedVideos");
        const videoSnap = await getDocs(videoRef);

        if (!videoSnap.empty) {
          const videoData = videoSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setVideos(videoData);
        } else {
          setError("등록된 관련 영상이 없습니다.");
        }
      } catch (error) {
        console.error("🔥 Firestore에서 관련 영상 불러오기 실패:", error);
        setError("관련 영상을 불러오는 중 오류 발생");
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (loading)
    return <h2 className={styles.loading}>⏳ 영상 불러오는 중...</h2>;
  if (error) return <h2 className={styles.notFound}>❌ {error}</h2>;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Related Videos</h2>
      <div className={styles.videoGrid}>
        {videos.map((video) => (
          <div key={video.id} className={styles.videoCard}>
            <img
              src={video.thumbnail}
              alt={video.title}
              className={styles.thumbnail}
            />
            <div className={styles.videoInfo}>
              <h3 className={styles.videoTitle}>{video.title}</h3>
              <div className={styles.tags}>
                {video.hashtags.map((tag, index) => (
                  <span key={index} className={styles.tag}>
                    #{tag}
                  </span>
                ))}
              </div>
              <a
                href={video.videoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.watchButton}
              >
                ▶ Watch Video
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedVideoList;
